import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { Box, Button, Datepicker, Label, Link, Text } from "@catchoftheday/cg-components";
import { minusOnePx, useMedia, useTheme } from "@catchoftheday/theme";
import { date, getSalesChannel } from "@catchoftheday/utilities";
import { COPY_GENERIC_ERROR, COPY_INVALID_DATE, COPY_PERSONAL_DETAILS_UPDATE_FAILURE, COPY_PERSONAL_DETAILS_UPDATE_SUCCESS } from "../../../const/index.js";
import { CustomerContext } from "../../../contexts/CustomerContext/CustomerContext.jsx";
import { useUpdatePersonalDetailsMutation } from "../../../generated/graphql.jsx";
import { triggerToast } from "../../../utilities/toast.jsx";
import { GenderPicker } from "../../pure/account-detail/GenderPicker/GenderPicker.jsx";
import { RequiredInput } from "../../pure/account-detail/RequiredInput/RequiredInput.jsx";
import { PersonalDetailsFormPlaceholder } from "./PersonalDetailsFormPlaceholder.jsx";
import { getRequiredInputProps } from "./utils.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var PersonalDetailsFormContainer = function PersonalDetailsFormContainer(_ref) {
  var host = _ref.host;

  var _useContext = useContext(CustomerContext),
      customer = _useContext.data,
      loading = _useContext.loading;

  var theme = useTheme();
  var isMobile = useMedia(["(max-width: ".concat(minusOnePx(theme.breakpoints.md), ")")], [true]);
  var isCOTD = !!host && getSalesChannel(host) === "COTD";

  var _useState = useState(null),
      formData = _useState[0],
      setFormData = _useState[1];

  var _useState2 = useState({
    email: "",
    phone: "",
    firstName: "",
    lastName: "",
    gender: "",
    dob: ""
  }),
      formError = _useState2[0],
      setFormError = _useState2[1];

  var _useUpdatePersonalDet = useUpdatePersonalDetailsMutation({
    onCompleted: function onCompleted(data) {
      var _data$updatePersonalD;

      if (((_data$updatePersonalD = data.updatePersonalDetails) === null || _data$updatePersonalD === void 0 ? void 0 : _data$updatePersonalD.__typename) === "UpdatePersonalDetailsSuccessResponse") {
        var _ref2 = data.updatePersonalDetails || {},
            customerData = _ref2.data,
            message = _ref2.message;

        setFormData({
          email: customerData === null || customerData === void 0 ? void 0 : customerData.email,
          phone: customerData === null || customerData === void 0 ? void 0 : customerData.phone,
          firstName: customerData === null || customerData === void 0 ? void 0 : customerData.firstName,
          lastName: customerData === null || customerData === void 0 ? void 0 : customerData.lastName,
          gender: customerData === null || customerData === void 0 ? void 0 : customerData.gender,
          dob: customerData === null || customerData === void 0 ? void 0 : customerData.dob
        });
        triggerToast({
          isError: false,
          message: message || COPY_PERSONAL_DETAILS_UPDATE_SUCCESS
        });
      } else {
        triggerToast({
          isError: true,
          message: data.updatePersonalDetails.error.message
        });
      }
    },
    onError: function onError() {
      triggerToast({
        isError: true,
        message: COPY_PERSONAL_DETAILS_UPDATE_FAILURE
      });
    }
  }),
      _useUpdatePersonalDet2 = _slicedToArray(_useUpdatePersonalDet, 2),
      updatePersonalDetails = _useUpdatePersonalDet2[0],
      mutationLoading = _useUpdatePersonalDet2[1].loading;

  var requiredInputProps = useMemo(function () {
    return getRequiredInputProps(isMobile, isCOTD);
  }, [isMobile, isCOTD]);
  var allowSubmit = Object.keys(formError).filter(function (key) {
    return !!formError[key];
  }).length === 0 && !mutationLoading;
  useEffect(function () {
    customer && setFormData({
      email: customer.email,
      phone: customer.phone,
      firstName: customer.firstName,
      lastName: customer.lastName,
      gender: customer.gender || null,
      dob: customer.dob
    });
  }, [customer]);

  var changeFormData = function changeFormData(fieldName, value) {
    setFormData(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, fieldName, value));
    });
  };

  var changeFormError = function changeFormError(fieldName, errorMessage) {
    setFormError(function (prev) {
      return _objectSpread(_objectSpread({}, prev), {}, _defineProperty({}, fieldName, errorMessage));
    });
  };

  var getInputValidationErrorMsg = function getInputValidationErrorMsg(_ref3) {
    var inputValue = _ref3.inputValue,
        requiredErrorMsg = _ref3.requiredErrorMsg,
        validationErrorMsg = _ref3.validationErrorMsg,
        validationPattern = _ref3.validationPattern;

    if (!inputValue) {
      return requiredErrorMsg;
    } else if (validationPattern && !validationPattern.test(inputValue)) {
      return validationErrorMsg || "";
    }

    return "";
  };

  var handleRequiredInputOnChange = function handleRequiredInputOnChange(_ref4) {
    var inputValue = _ref4.inputValue,
        inputName = _ref4.inputName,
        requiredErrorMsg = _ref4.requiredErrorMsg,
        validationErrorMsg = _ref4.validationErrorMsg,
        validationPattern = _ref4.validationPattern;
    changeFormData(inputName, inputValue);
    changeFormError(inputName, getInputValidationErrorMsg({
      inputValue: inputValue,
      requiredErrorMsg: requiredErrorMsg,
      validationErrorMsg: validationErrorMsg,
      validationPattern: validationPattern
    }));
  };

  var handleDatepickerOnChange = function handleDatepickerOnChange(value, context) {
    var errorMessage = context.validationError ? COPY_INVALID_DATE : "";
    changeFormData("dob", date.format(value || "", "yyyy-MM-dd"));
    changeFormError("dob", errorMessage);
  };

  var submitForm = useCallback(function () {
    if (formData) {
      var tempValidationErrors = Object.keys(requiredInputProps).map(function (fieldName) {
        var errorMsg = getInputValidationErrorMsg({
          inputValue: formData[fieldName],
          requiredErrorMsg: requiredInputProps[fieldName].requiredErrorMsg,
          validationErrorMsg: requiredInputProps[fieldName].validationErrorMsg,
          validationPattern: requiredInputProps[fieldName].validationPattern
        });
        changeFormError(fieldName, errorMsg);
        return errorMsg;
      });
      var isError = tempValidationErrors.filter(function (error) {
        return !!error;
      }).length > 0;

      if (!isError) {
        updatePersonalDetails({
          variables: {
            input: formData
          }
        });
      }
    }
  }, [formData, updatePersonalDetails]);
  if (loading) return ___EmotionJSX(PersonalDetailsFormPlaceholder, null);

  if (!loading && !formData) {
    return ___EmotionJSX(Text, null, COPY_GENERIC_ERROR);
  }

  var gender = formData.gender,
      dob = formData.dob;
  var errorDob = formError.dob;
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Box, {
    display: "grid",
    rowGap: 5,
    columnGap: 5,
    gridTemplateColumns: {
      xs: "repeat(1, 1fr)",
      md: "repeat(2, 1fr)"
    }
  }, Object.keys(requiredInputProps).map(function (fieldName) {
    return ___EmotionJSX(RequiredInput, {
      key: "input-".concat(fieldName),
      id: fieldName,
      name: fieldName,
      label: requiredInputProps[fieldName].label,
      value: formData[fieldName],
      errorMessage: formError[fieldName],
      onChange: function onChange(event) {
        return handleRequiredInputOnChange({
          inputValue: event.target.value,
          inputName: fieldName,
          requiredErrorMsg: requiredInputProps[fieldName].requiredErrorMsg,
          validationErrorMsg: requiredInputProps[fieldName].validationErrorMsg,
          validationPattern: requiredInputProps[fieldName].validationPattern
        });
      }
    });
  }), ___EmotionJSX(Box, {
    gridColumn: "1/2"
  }, ___EmotionJSX(GenderPicker, {
    selected: gender || null,
    onChange: function onChange(gender) {
      return changeFormData("gender", gender);
    }
  })), ___EmotionJSX(Box, {
    gridColumn: "1/2"
  }, ___EmotionJSX(Label, {
    htmlFor: "dob"
  }, "Birthday"), ___EmotionJSX(Datepicker, {
    slotProps: {
      textField: {
        id: "dob",
        name: "dob",
        title: "Birthday",
        placeholder: "DD/MM/YYYY",
        fullWidth: true
      }
    },
    value: dob ? new Date(dob) : null,
    onChange: handleDatepickerOnChange
  }), errorDob && ___EmotionJSX(Text, {
    color: "error",
    fontSize: "small",
    mb: 0,
    mt: 1
  }, errorDob))), ___EmotionJSX(Link, {
    href: "/reset-password",
    mb: 4,
    mt: 6,
    display: "inline-block"
  }, "Change your password"), ___EmotionJSX(Button, {
    maxWidth: 125,
    display: "block",
    disabled: !allowSubmit,
    onClick: submitForm
  }, "Save"));
};